import React from 'react';
import { useTranslation } from '../../../../lib/i18n';

export function FourUHeader() {
  const { t } = useTranslation();
  return (
    <div style={styles.container} >
      <span aria-hidden style={styles.text} />
      {t('chat.forYou')}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {

    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 15,
    letterSpacing: '0',
    textTransform: 'none',
    fontFamily: 'var(--brand-font-serif)',
    color: 'rgba(var(--ink-rgb),0.55)',
    marginBottom: 12,

  },
  text: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background:
      'linear-gradient(135deg, var(--avatar-stop-1), rgba(var(--accent-glow-rgb), 0.92))',
    boxShadow: '0 0 10px rgba(var(--accent-glow-rgb), 0.5)',

  }
}
